import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const MaterialCreate = props => (
  <CommonCreate
    {...{
      ...props,
      fields: getInputs(),
    }}
  />
);
